import React from 'react';
import links from '../../../../../config/links';
import Img from '../../../Img';
import SupportLink from '../../../Links/SupportLink';

const EventPayment = (props) => {
    const {
        paymentAccountIsSetup,
        stripeUrl,
        activePaymentsEnabled,
        error,
        isOwner,
    } = props;

    const setupPaymentAccount = () => {
        window.location.href = stripeUrl;
    };

    return (
        <div className={`col-12 mt24`}>
            <div className="row">
                <div className="col-12 text-center">
                    <div className="payment-provider-wrapperp16">
                        {(paymentAccountIsSetup && activePaymentsEnabled) ? (
                            <div className="payment-account-linked">
                                <div className="check-wrapper">
                                    <i className="utr utr-check-circle" />
                                </div>
                                <span className="text-teal">Perfect! Your account is linked.</span>
                            </div>
                        ) : (
                            <React.Fragment>
                                {error ? (
                                    <div className="payment-account-linked">
                                        <div className="check-wrapper">
                                            <i className="utr utr-clear" />
                                        </div>
                                        <span className="text-teal">You account could not be linked. Please contact <SupportLink>support team</SupportLink> for assistance.</span>
                                    </div>
                                ) : (
                                    <Img className="payment-provider-logo mb16" src={`/img/logos/stripe_logo.svg`} />
                                )}
                            </React.Fragment>
                        )}

                        {error && <p className={`text-error`}>Error: {error}</p>}

                        <button
                            type="button"
                            disabled={(paymentAccountIsSetup && activePaymentsEnabled) || !isOwner}
                            className={`btn btn-primary btn-xl text-uppercase btn-block`}
                            onClick={setupPaymentAccount}
                        >
                            {(paymentAccountIsSetup && activePaymentsEnabled) ? 'Account Linked' : `Set up Stripe'}`}
                        </button>
                    </div>
                </div>
            </div>
            {!paymentAccountIsSetup && (
                <div className="row">
                    <div className="col-10 offset-1 fs14">
                        <div className="wizard-tip mt24">
                            Tip: You need the following information:
                            <ul>
                                <li>SSN/EIN (if business)</li>
                                <ul>
                                    <li>SSN/EIN are required in the United States, you may need a similar ID/info for the nation you are in</li>
                                </ul>
                                <li>Business Controller & Business Owner Details</li>
                                <li>Business Banking Information (Account #, Routing #)</li>
                            </ul>
                            <a href={links.wePayOrganizerFaq} target="_blank" rel="noopener noreferrer">Learn more</a>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EventPayment;
